// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarItem from "./SidebarItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (setIsDropdownShown) {
    return function (setBar) {
      return function (sidebarItems) {
        const match = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
        const identity = match[0];
        const match$1 = React.useState(function () {
              return false;
            });
        const setIsProfileHovered = match$1[1];
        const isProfileHovered = match$1[0];
        const match$2 = Buhta_core__Tenant.useTenant(undefined);
        const tenant = match$2[0];
        let userpic;
        let exit = 0;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          exit = 1;
        } else {
          const identityProfile = identity._0;
          userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
                  children: identityProfile.first_name.substring(0, 1),
                  className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
                }) : JsxRuntime.jsx("img", {
                  className: "w-5 h-5 rounded-50pct",
                  src: identityProfile.userpic_url
                });
        }
        if (exit === 1) {
          userpic = JsxRuntime.jsx("img", {
                className: "w-5 h-5 rounded-50pct",
                src: StaticAsset.src("/static/icons/profile-photo.png")
              });
        }
        let fullName;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          fullName = "Профиль";
        } else {
          const identityProfile$1 = identity._0;
          fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
        }
        const contextRoute = function (route) {
          return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
        };
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(sidebarItems, (function (index, item) {
                                        const Key = "sidebar__item_" + String(index);
                                        return JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
                                                    item: item,
                                                    setBar: setBar
                                                  }, Key);
                                      }))),
                            className: "mt-6"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
                                    item: {
                                      label: "Настройки",
                                      route: contextRoute({
                                            TAG: /* Settings */8,
                                            _0: /* General */0
                                          }),
                                      isActiveRoute: (function (param) {
                                          if (typeof param === "number" || param.TAG !== /* Settings */8) {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }),
                                      eventName: "",
                                      bar: "settings",
                                      isHidden: false
                                    },
                                    setBar: setBar
                                  }, "sidebar__item_settings"),
                              JsxRuntime.jsxs("button", {
                                    children: [
                                      userpic,
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: Cn.fromList({
                                                  hd: "truncate ml-4",
                                                  tl: {
                                                    hd: isProfileHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                                                    tl: /* [] */0
                                                  }
                                                }),
                                            children: fullName
                                          })
                                    ],
                                    className: Cn.fromList({
                                          hd: "whitespace-nowrap px-6 flex py-1.5 hover:w-full",
                                          tl: {
                                            hd: isProfileHovered ? "bg-white/8" : "hover:bg-white/8",
                                            tl: /* [] */0
                                          }
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(setIsDropdownShown, (function (param) {
                                                return true;
                                              }));
                                      }),
                                    onMouseEnter: (function (param) {
                                        Curry._1(setIsProfileHovered, (function (param) {
                                                return true;
                                              }));
                                      }),
                                    onMouseLeave: (function (param) {
                                        Curry._1(setIsProfileHovered, (function (param) {
                                                return false;
                                              }));
                                      })
                                  })
                            ],
                            className: "absolute bottom-6 space-y-2 w-[244px]"
                          })
                    ]
                  });
      };
    };
  };
}

function SidebarMain(Props) {
  return Curry._2(make(Props.org)(Props.setIsDropdownShown), Props.setBar, Props.sidebarItems);
}

const make$1 = SidebarMain;

export {
  make$1 as make,
}
/* Buhta_cabinet__Route Not a pure module */
